import { computed } from 'vue'
import { useStore } from 'vuex'
import AnalyticsService from '@emcd-shared/analytics-service'

export function usePartner() {
  const store = useStore()

  const partnerId = computed(() => store.getters['partner/partnerId'])
  const partnerType = computed(() => store.getters['partner/partnerType'])
  const products = computed(() => store.state.partner.products)
  const isLoaded = computed(() => store.state.partner.isLoaded)
  const isLoading = computed(() => store.state.partner.isLoading)

  async function fetchPartnerInfo() {
    try {
      await store.dispatch('partner/fetchPartnerInfo')
    } catch (error) {
      AnalyticsService.addBreadcrumb(
        'usePartner',
        'Failed to fetch partner info'
      )
      throw error
    }
  }

  function isProductAvailable(productName) {
    return store.getters['partner/isProductAvailable'](productName)
  }

  async function checkProductAccess(productName) {
    if (!isLoaded.value && !isLoading.value) {
      try {
        await store.dispatch('partner/fetchPartnerInfo')
      } catch (error) {
        AnalyticsService.addBreadcrumb(
          'usePartner',
          'Failed to fetch partner info, allowing access'
        )
        return true
      }
    }

    if (isLoading.value) {
      return true
    }

    const hasAccess = isProductAvailable(productName)

    if (!hasAccess) {
      AnalyticsService.addBreadcrumb(
        'usePartner',
        `Product ${productName} not available`
      )
      store.dispatch('ui/showProductActivationModal', 'product')
    }

    return hasAccess
  }

  return {
    partnerId,
    partnerType,
    products,
    isLoaded,
    isLoading,
    fetchPartnerInfo,
    isProductAvailable,
    checkProductAccess,
  }
}
